module.exports = __webpack_public_path__ + "img/icon-baccarat-2.cbd6246c.png";